import React from "react";
//#region types
import { EditableTableCellProps } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
//#endregion
//#region components
import useCheckVisibility from "../../hooks/useCheckVisibility";
import MasterRowSummaryView from "../../../tables/masterRowSummaryView";
import FormFieldContainerMemoized from "../../formFieldContainerMemoized";
import { TableCell } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const EditableTableCell: React.FC<EditableTableCellProps> = (props) => {
  const {
    rowIndex,
    currentField,
    cellValue,
    tabIndex,
    fieldName,
    fieldNameForOptionalCheck,
    errors,
    touched,
    isCompactTable,
    hasMasterRowEnabled,
    widthPercentage,
    validationSchema,
    parentRowValues,
    onFocus,
    tableReadonly,
    onMasterRowChange,
    allowReOrderingOfRows,
  } = props;

  const { getFieldHidden } = useCheckVisibility();
  const hidden = getFieldHidden(currentField.hidden);

  return !hidden ? (
    <TableCell
      className={currentField.classes?.formControl}
      onDragStart={
        allowReOrderingOfRows
          ? (event) => {
              event.stopPropagation();
              event.preventDefault();
            }
          : undefined
      }
      draggable={allowReOrderingOfRows}
      style={{
        width: `${widthPercentage}%`,
        textAlign: isCompactTable && currentField.type === FormEnums.FormFieldType.TOGGLE ? "end" : undefined,
      }}
    >
      {!!hasMasterRowEnabled && rowIndex > 0 && tabIndex ? (
        <MasterRowSummaryView entityName={LocalizationHelperInstance.getFormattedMessage(currentField.label)}>
          <FormFieldContainerMemoized
            name={fieldName}
            nameForOptionalCheck={fieldNameForOptionalCheck}
            errors={errors}
            touched={touched}
            hideErrorBubble
            field={{
              ...currentField,
              label: "",
              readonly: true,
              overrideHideErrorBubble: false,
            }}
            value={cellValue}
          />
        </MasterRowSummaryView>
      ) : (
        <FormFieldContainerMemoized
          name={fieldName}
          nameForOptionalCheck={fieldNameForOptionalCheck}
          value={cellValue}
          field={{
            ...currentField,
            onChangeHandler:
              !!hasMasterRowEnabled && tabIndex
                ? onMasterRowChange.bind(null, currentField.onChangeHandler ?? (() => {}))
                : currentField.onChangeHandler,
            onFocusHandler: onFocus,
            readonly: currentField.readonly ?? tableReadonly,
          }}
          errors={errors}
          touched={touched}
          hideSuccess
          hideErrorBubble
          refValues={parentRowValues}
          messagePlacement="top"
          validationSchema={validationSchema}
        />
      )}
    </TableCell>
  ) : (
    <></>
  );
};

export default EditableTableCell;
